"use strict";


export function urlToJson(url) {
  let index = url.indexOf('?');
  url = url.match(/\?([^#]+)/)[1];
  let obj = {},
    arr = url.split('&');
  for (let i = 0; i < arr.length; i++) {
    let subArr = arr[i].split('=');
    obj[subArr[0]] = decodeURIComponent(subArr[1]);
  }
  return obj;

}


export function jsonToUrl(param) {
  let tempArr = [];
  for (let i in param) {
    var key = encodeURIComponent(i);
    var value = encodeURIComponent(param[i]);
    tempArr.push(key + '=' + value);
  }
  return "?" + tempArr.join('&');
}




// WEBPACK FOOTER //
// ./src/common/util/url.util.js